/* eslint-disable */
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui'
import Highchart from "highcharts/highcharts"
import HighchartsVue from "highcharts-vue"
import stockInit from "highcharts/modules/stock"
import 'element-ui/lib/theme-chalk/index.css'
import 'swiper/dist/css/swiper.css'
import { Notify } from 'vant'
import vueTap from 'v-tap'
import './utils/dingConfig.js'
import { wxAuth } from '@utils/plugin'
import QRcode from './components/QrCode/index'
import Advertisement from './components/Advertisement/index'

// import vConsole from '../vconsole'
// Vue.prototype.vConsole = vConsole;

Vue.use(vueTap)
Vue.use(Advertisement)
Vue.use(QRcode)
Vue.use(ElementUI)
Vue.use(Notify)
stockInit(Highchart)
Vue.use(HighchartsVue)

Vue.config.productionTip = false

router.beforeEach((to, _, next) => {
  if (to.meta && to.meta.title) {
    document.title = to.meta.title
  }
  next()
})

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
